import { deleteQueryParam, getQueryParam, pushQueryParam } from './_queryParams'
import { showLoader } from './_utils'
import { handleQuery, updateSort } from '../pagination/_pagination'

const initializeContentTypeFilters = async (el, container) => {
  const currentFilter = getQueryParam('filterText')

  if (!['all', 'siteonly', 'pressreleases'].includes(currentFilter)) {
    deleteQueryParam('filterText')
  }

  el.forEach((input) => {
    if (input.value === currentFilter) {
      input.checked = true
    }
    input.addEventListener('change', async (event) => {
      const currentQuery = getQueryParam('q')
      // Show any additional filter areas connected to this selection
      if (event.target.checked && event.target?.value) {
        container.querySelectorAll('[data-filter-append]').forEach((div) => {
          div.classList.add('hide')
          if (div.getAttribute('data-filter-append') === event.target.value) {
            div.classList.remove('hide')
          }
        })
      }
      const currentFilter = getQueryParam('filterText')

      if (currentFilter !== 'pressreleases' || event.target?.value !== 'pressreleases') {
        deleteQueryParam('pressYear')
        deleteQueryParam('pressCat')
      }
      // If there's a search present, we need to rerun our render
      if (currentQuery && currentFilter !== event.target.value) {
        showLoader(container)
        handleQuery(currentQuery, { filterText: event.target.value }, true)
      }
    })
  })
}

const removeInvalidSorts = (currentFilter) => {
  if (!['relevance', 'datedescending', 'dateascending'].includes(currentFilter)) {
    deleteQueryParam('selectSort')
  }
}

const initializeSortOrderFilters = (el, container) => {
  const currentFilter = getQueryParam('selectSort')
  removeInvalidSorts(currentFilter)

  el.forEach((input) => {
    // On initial page load, check the value of the currently active filter
    if (input.value === currentFilter) {
      input.checked = true
    }

    input.addEventListener('change', async (event) => {
      // This may have changed, get the current value
      const currentQuery = getQueryParam('q')
      const currentFilter = getQueryParam('selectSort')

      // If there's a search present, we need to rerun our render
      if (currentQuery && currentFilter !== event.target.value) {
        pushQueryParam('selectSort', event.target.value)
        showLoader(container)
        updateSort(event.target.value)
      }
    })
  })
}

const initializePressFilters = (el, container) => {
  // Show the Press Release selects if required by state
  const currentContentType = getQueryParam('filterText')
  if (currentContentType === 'pressreleases') {
    container.querySelectorAll('[data-filter-append]').forEach((div) => {
      div.classList.add('hide')
      if (div.getAttribute('data-filter-append') === currentContentType) {
        div.classList.remove('hide')
      }
    })
  }

  el.forEach((input) => {
    const filterName = input.name

    // Set value based on query state
    const currentSelected = getQueryParam(filterName)
    if (currentSelected) {
      input.value = currentSelected
    }
    input.addEventListener('change', async (event) => {
      const currentQuery = getQueryParam('q')

      if (event.target.value == '') {
        deleteQueryParam(event.target.name)
      } else {
        pushQueryParam(event.target.name, event.target.value)
      }
      showLoader(container)
      handleQuery(currentQuery, { filterText: 'pressreleases', [event.target.name]: event.target.value }, true)
    })
  })
}

export { initializeContentTypeFilters, initializeSortOrderFilters, initializePressFilters }
